import { render } from "./DexAutocomplete.vue?vue&type=template&id=5d749dcf"
import script from "./DexAutocomplete.vue?vue&type=script&lang=js"
export * from "./DexAutocomplete.vue?vue&type=script&lang=js"

import "./DexAutocomplete.vue?vue&type=style&index=0&id=5d749dcf&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__